import { render, staticRenderFns } from "./suppliers-edit-modal.vue?vue&type=template&id=22001c48&scoped=true"
import script from "./suppliers-edit-modal.vue?vue&type=script&lang=js"
export * from "./suppliers-edit-modal.vue?vue&type=script&lang=js"
import style0 from "./suppliers-edit-modal.vue?vue&type=style&index=0&id=22001c48&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22001c48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22001c48')) {
      api.createRecord('22001c48', component.options)
    } else {
      api.reload('22001c48', component.options)
    }
    module.hot.accept("./suppliers-edit-modal.vue?vue&type=template&id=22001c48&scoped=true", function () {
      api.rerender('22001c48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/entitites-lists-with-search/suppliers-edit-modal.vue"
export default component.exports